import { Pipe, PipeTransform } from "@angular/core";
import { formatAmount } from "src/app/service/modulo-desempeno/performance-number";

/**
 * `{{ valor | amount }}`: el número para mostrar con coma cada mil y sin
 * decimales cuando son solo ceros (45000 → "45,000", "160.00" → "160",
 * 1234567.5 → "1,234,567.5"). Envuelve {@link formatAmount}; vacío con
 * `null`/`undefined`/"" y el texto tal cual si no es un número.
 *
 * Es el que va en toda plantilla del módulo de desempeño que pinte un número:
 * metas, logrados, puntajes, pesos, porcentajes, montos. `smartNumber` NO sirve
 * (no agrupa miles y redondea a un decimal). No va en fechas, años ni ids.
 */
@Pipe({
	name: "amount",
})
export class AmountPipe implements PipeTransform {
	transform(value: unknown): string {
		return formatAmount(value);
	}
}
